<template>
  <MediaImageViewerLayout :image-url="url" />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import MediaImageViewerLayout from './MediaImageViewerLayout.vue'

export default defineComponent({
  components: {
    MediaImageViewerLayout,
  },
  props: {
    url: {
      required: true,
      type: String,
      validator: (url: string) => url.length > 0,
    },
  },
  emits: {
    ended: () => true,
  },
  setup(_, { emit }) {
    emit('ended')
  },
})
</script>
